import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Cart1 = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M1.25 2.5c0-.69.56-1.25 1.25-1.25h3.056c.617 0 1.142.45 1.235 1.061l1.366 8.939h7.204l2.185-7.836a1.25 1.25 0 1 1 2.408.672l-2.44 8.75a1.25 1.25 0 0 1-1.204.914H7.082a1.25 1.25 0 0 1-1.235-1.061L4.482 3.75H2.5c-.69 0-1.25-.56-1.25-1.25m6.875 16.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75m7.5 0a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75M10 7.5a1.25 1.25 0 1 0 0 2.5h3.75a1.25 1.25 0 1 0 0-2.5z" }) }));
});
Cart1.displayName = 'Cart1';
Cart1.__iconComponentType = 'standard';
export default Cart1;
//# sourceMappingURL=Cart1.js.map